<template>
	<v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2" v-if="id > 0">Edit Student Inhaalles (coördinator)</span>
				<span class="pl-2" v-else>Add Student Inhaalles (coördinator)</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-text>
			<v-form>
				<v-row>
					<v-col cols="12" sm="6">
						<p class="font-weight-black title">School info</p>
						<v-select
							dense
							:items="schoolyears"
							item-text="name"
							item-value="id"
							v-model="form.schoolyear_id"
							filled
							label="Schoolyear"
						></v-select>
						<v-select
							dense
							:items="studys"
							item-text="name"
							item-value="id"
							v-model="form.study_id"
							filled
							label="Opleiding"
						></v-select>
						<v-select
							dense
							:items="classs"
							item-text="name"
							item-value="id"
							v-model="form.class_id"
							filled
							label="Klas"
						></v-select>
					</v-col>

					<v-col cols="12" sm="6">
						<p class="font-weight-black title">Student</p>
						<v-select
							dense
							:items="students"
							item-text="tbl_student.display_name"
							item-value="tbl_student.id"
							v-model="form.student_id"
							filled
							label="Student"
						></v-select>
					</v-col>

					<v-col cols="12" sm="6">
						<p class="font-weight-black title">Inhaalles</p>
						<v-select
							dense
							:items="class1"
							item-text="name"
							item-value="id"
							v-model="form.class_overtake_id"
							filled
							label="Inhaal klas"
						></v-select>
						<v-select
							dense
							:items="periodes"
							item-text="name"
							item-value="id"
							v-model="form.periode_id"
							filled
							label="Periode"
						></v-select>
						<v-select
							dense
							:items="subjects"
							item-text="name"
							item-value="id"
							v-model="form.subject_id"
							filled
							label="Deelkwalificatie"
						></v-select>
						<v-select
							dense
							:items="modules"
							item-text="module"
							item-value="id"
							v-model="form.module_id"
							filled
							label="Module"
						></v-select>
						<v-textarea
							filled
							name="input-7-4"
							label="Motivatie"
							v-model="form.description"
						></v-textarea>
						<v-checkbox
							v-model="approvalChecked"
							label="Coördinator goedkeuring"
						></v-checkbox>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
		<v-card-actions>
			<v-btn color="primary" @click="submitForm()" depressed :loading="saving">Save</v-btn>
			<v-btn color="dark" @click="$router.go(-1)" depressed>Cancel</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import Axios from "axios";
import { API_ROOT } from "../../config";

const ax = Axios.create({
	baseURL: API_ROOT["osbod_salary"],
	timeout: 60000
});

export default {
	name: "student_overtake_class_coordinator_edit",
	props: ["id"],
	data() {
		return {
			user: JSON.parse(localStorage.getItem("user") || "{}"),
			saving: false,
			schoolyears: [],
			classs: [],
			class1: [],
			students: [],
			studys: [],
			periodes: [],
			subjects: [],
			modules: [],
			approvalChecked: false,
			form: {
				id: 0,
				schoolyear_id: null,
				student_id: null,
				class_id: null,
				subject_id: null,
				module_id: null,
				description: null,
				periode_id: null,
				class_overtake_id: null,
				study_id: null,
				coordinator_approval: 0,
				registered_by_user: null,
				reg_date: null
			}
		};
	},
	created: function() {
		this.getSchoolyears();
		this.getPeriode();
		this.getStudy();
		if (this.id > 0) {
			this.getStudentOvertakeSubject(this.id);
		}
	},
	watch: {
		"form.study_id": function() {
			this.getClass();
		},
		"form.class_id": function() {
			this.getStudent();
		},
		"form.class_overtake_id": function() {
			this.getSubject();
		},
		"form.periode_id": function() {
			this.getSubject();
		},
		"form.subject_id": function() {
			this.getModule();
		}
	},
	methods: {
		getSchoolyears: function() {
			var self = this;
			ax.get("/schoolyear/all").then(function(response) {
				self.schoolyears = response.data || [];
			});
		},
		getStudy: function() {
			var self = this;
			ax.get("/study/coordinator_study", {
				params: {
					user_id: this.user.id
				}
			}).then(function(response) {
				self.studys = response.data || [];
			});
		},
		getStudent: function() {
			var self = this;
			if (!self.form.class_id || !self.form.schoolyear_id) return;
			ax.get("/student_class/selected_class_retake/", {
				params: {
					class_id: self.form.class_id,
					schoolyear_id: self.form.schoolyear_id
				}
			}).then(function(response) {
				self.students = response.data || [];
			});
		},
		getSubject: function() {
			var self = this;
			if (!self.form.class_overtake_id || !self.form.periode_id) return;
			ax.get("/subject/selected_class/", {
				params: {
					class_id: self.form.class_overtake_id,
					periode_id: self.form.periode_id
				}
			}).then(function(response) {
				self.subjects = response.data || [];
			});
		},
		getModule: function() {
			var self = this;
			if (
				!self.form.class_overtake_id ||
				!self.form.periode_id ||
				!self.form.subject_id
			) {
				return;
			}
			ax.get("/teacher_subject_class/all_module/", {
				params: {
					class_id: self.form.class_overtake_id,
					periode_id: self.form.periode_id,
					subject_id: self.form.subject_id
				}
			}).then(function(response) {
				self.modules = response.data || [];
			});
		},
		getClass: function() {
			var self = this;
			if (!self.form.study_id) return;
			ax.get("/school_class/selected_study/", {
				params: {
					study_id: self.form.study_id
				}
			}).then(function(response) {
				self.classs = response.data || [];
				self.class1 = response.data || [];
			});
		},
		getPeriode: function() {
			var self = this;
			ax.get("/periode/all").then(function(response) {
				self.periodes = response.data || [];
			});
		},
		getStudentOvertakeSubject: function(id) {
			var self = this;
			ax.get("/student_overtake_class/single/" + id).then(function(response) {
				self.form = Object.assign({}, self.form, response.data || {});
				self.approvalChecked = !!Number(
					response.data && response.data.coordinator_approval
				);
				self.getClass();
				self.getStudent();
				self.getSubject();
				self.getModule();
			});
		},
		submitForm() {
			var self = this;
			this.form.coordinator_approval = this.approvalChecked ? 1 : 0;
			this.form.registered_by_user = this.user.id;
			if (!this.form.reg_date) {
				this.form.reg_date = new Date();
			}
			this.saving = true;

			var request;
			if (this.form.id > 0) {
				request = ax.post(
					"/student_overtake_class/update/" + this.form.id,
					this.form
				);
			} else {
				request = ax.post("/student_overtake_class/create", this.form);
			}

			request
				.then(function() {
					self.saving = false;
					self.$router.push({
						path: "/schooladmin/student_overtake_class_coordinator"
					});
				})
				.catch(function() {
					self.saving = false;
				});
		}
	}
};
</script>
